import type { ComponentProps } from 'react'

import type { VariantProps } from '@joyful/utils'
import { tv } from '@joyful/utils'

import { Slot } from './Slot'

export const tabularVariants = tv({
  base: 'tabular-nums',

  defaultVariants: {
    size: 'inherit',
    tone: 'inherit',
    weight: 'normal',
  },

  variants: {
    size: {
      '2xl': 'text-2xl leading-none',
      '3xl': 'text-3xl leading-none tracking-tight',
      '5xl': 'text-5xl leading-none tracking-tight',
      base: 'text-base',
      inherit: {},
      lg: 'text-lg',
      sm: 'text-sm',
      xl: 'text-xl leading-none',
      xs: 'text-xs',
    },

    tone: {
      content: 'text-tremor-content',
      emphasis: 'text-tremor-content-emphasis',
      inherit: {},
      strong: 'text-tremor-content-strong',
      subtle: 'text-tremor-content-subtle',
    },

    weight: {
      medium: 'font-medium',
      normal: {},
      semibold: 'font-semibold',
    },
  },
})

export interface TabularProps
  extends
    Omit<ComponentProps<'span'>, 'className'>,
    VariantProps<typeof tabularVariants> {
  /**
   * @default false
   */
  asChild?: boolean
}

export function Tabular({
  asChild = false,
  children,
  size,
  tone,
  weight,
  ...restProps
}: TabularProps) {
  const Component = asChild === true ? Slot : 'span'

  return (
    <Component
      className={tabularVariants({ size, tone, weight })}
      {...restProps}
    >
      {children}
    </Component>
  )
}
